import { render, staticRenderFns } from "./TromsoeAI.vue?vue&type=template&id=1c45748b&"
import script from "./TromsoeAI.vue?vue&type=script&lang=ts&"
export * from "./TromsoeAI.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports